(() => {
  const initMenu = () => {
    const menuWrapper = document.getElementById("submenu-container"),
      navButtonLinks = document.querySelectorAll(".nav-link-custom span"),
      navButtons = document.querySelectorAll(".nav-link-custom"),
      extension = document.querySelector(".bg-extend");

    let menuTimer;

    const mobBreakpoint = 1025;
    let currentMenu;
    // window.outerWidth > mobBreakpoint ? setNavHeight() : null;
    
    const setPanelHeight = () => {
      
      let max = Math.max(
        ...Object.keys(menuData).map((key) => {
          return menuData[key].length;
        }),
      );
      // * experimental
      const lMax = menuData.linkMax; // max links allowed in column (linked to Liquid variable)
      const sLink = document.querySelector(
        ".secondary-link-group li",
      );
      const sLinkBaseHeight = sLink.offsetHeight;
      // const sLinkStyles = window.getComputedStyle(sLink);
      // const sLinkMarginBlock = parseFloat(sLinkStyles["marginTop"]) + parseFloat(sLinkStyles["marginBottom"]);
      // const sLinkHeight = sLinkBaseHeight + sLinkMarginBlock;
      const sLinkListHeight = lMax * sLinkBaseHeight;
      
      const parentStyles = window.getComputedStyle(document.querySelector(".secondary-links-wrapper"));
      const parentPaddingBlock = parseFloat(parentStyles["paddingTop"]) + parseFloat(parentStyles["paddingBottom"]);
      const navHeight = sLinkListHeight + parentPaddingBlock;
      menuWrapper.style.height = navHeight;
      // * /experimental
      //menuWrapper.style.height = `${28 * max * 2}px`;
    };
    setPanelHeight();

    navButtonLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        if (e.target.parentElement.classList.contains("hover")) {
          return;
        } else {
          navButtons.forEach((btn) => btn.classList.remove("hover"));
          e.target.parentElement.classList.add("hover");
          menuWrapper.classList.add("active");

          let navName = link.textContent.toLowerCase().replace(" ", "-").trim();
          currentMenu = navName;
          let colors = getColorProps(menuData[currentMenu][0].title);

          extension.classList.contains("inter-panel")
            ? extension.classList.remove("inter-panel")
            : null;
          extension.style.backgroundColor = colors.background;
          initPanels(navName, colors);
        }
      });
    });

    const initPanels = (primaryNavLink, colors) => {
      document.querySelectorAll(".nav-submenu").forEach((panel) => {
        const clearTimer = () => {
          clearTimeout(menuTimer);
        };
        panel.addEventListener("mouseenter", () => {
          menuTimer ? clearTimer() : null;
          panel.removeEventListener("mouseenter", clearTimer);
        });
        let panelImages = panel.querySelectorAll(".nav-menu-img-col");
        panelImages.forEach((img) =>
          img.classList.remove("current-panel", "fade-in"),
        );
        panel.classList.remove("active");

        if (panel.classList.contains(primaryNavLink)) {
          panel.classList.add("active");

          panel
            .querySelectorAll(".primary-list-group li")
            .forEach((listItem, i) => {
              i > 0
                ? (listItem.style.color = "inherit")
                : (listItem.style.color = colors.text);
            });
          let indicator = panel.querySelector(".primary-link-indicator");
          indicator.style.transform = "translateX(0px)";
          indicator.querySelector("path").style.fill = colors.text;

          let panelPanes = panel.querySelectorAll(".secondary-link-group");
          let paneImages;
          panelPanes.forEach((pane, i) => {
            i == 0
              ? (pane.classList.add("active"),
                (paneImages = pane.querySelectorAll(".nav-menu-img-col")),
                (pane.parentElement.style.backgroundColor = colors.background),
                (pane.style.color = colors.text))
              : pane.classList.remove("active");
          });
          paneImages.forEach((img) => {
            img.classList.add("current-panel");
            setTimeout(() => {
              img.classList.add("fade-in");
            }, 200);
          });

          panel
            .querySelectorAll(".primary-list-group li")
            .forEach((item, i) => {
              item.addEventListener("mouseenter", (e) => {
                handleSecondaryHover(e, i, panel);
              });
            });
        }
      });
    };

    const handleSecondaryHover = (e, i, p) => {
      const target = e.target.childNodes[1].childNodes[0].textContent
        .toLowerCase()
        .trim()
        .replace(/[^\w\s]/gi, "");
      let panel = p.querySelector(".secondary-links-wrapper");
      let activePane = panel?.querySelector(".secondary-link-group.active");

      if (activePane?.classList.contains(`${target}-secondary-links`)) {
        return;
      } else {
        const itemHeight = $(e.target).outerHeight(true);
        const primaryList = document.querySelectorAll(".primary-list-group li");
        const indicator = p.querySelector(".primary-link-indicator");
        primaryList.forEach((listItem) => (listItem.style.color = "inherit"));

        let colors = getColorProps(target);

        extension.classList.add("inter-panel");
        extension.style.backgroundColor = colors.background;
        panel.style.backgroundColor = colors.background;
        panel.style.color = colors.text;
        indicator.querySelector("path").style.fill = colors.text;
        indicator.style.transform = `translateY(${itemHeight * i}px)`;
        e.target.style.color = colors.text;

        let sLinkContainers = panel.querySelectorAll(".secondary-link-group");
        sLinkContainers.forEach((container) => {
          const paneImages = container.querySelectorAll(".nav-menu-img-col");
          paneImages.forEach((img) => {
            img.classList.remove("current-panel", "fade-in");
          });
          container.classList.remove("active");
          if (
            container.classList.contains(
              `${target.replaceAll(" ", "-")}-secondary-links`,
            )
          ) {
            container.classList.add("active");
            const activePaneImages =
              container.querySelectorAll(".nav-menu-img-col");
            activePaneImages.forEach((img) => {
              img.classList.add("current-panel");
              setTimeout(() => {
                img.classList.add("fade-in");
              }, 200);
            });
          }
        });
      }
    };

    function setNavHeight() {
      let navContainer = document.querySelector(".tt-desctop-menu");
      let navWrapperHeight = document.getElementById(
        "desktop-header-container",
      ).offsetHeight;
      navContainer
        ? (navContainer.style.height = `${navWrapperHeight}px`)
        : null;
    }

    // window.addEventListener('resize', (e) => {
    //   let w = e.target.outerWidth;
    //   w > mobBreakpoint ? setNavHeight() : null;
    // });

    const getColorProps = (target) => {
      let sTarget = target.trim().replace(/[ ]/gi, "-");
      return menuData[currentMenu]
        .filter((item) => item.title === sTarget)
        .reduce(
          (acc, val) => ({ ...acc, background: val.bg, text: val.color }),
          {},
        );
    };

    const handleMenuClose = () => {
      document
        .getElementsByTagName("header")[0]
        .addEventListener("mouseleave", () => {
          menuWrapper.classList.remove("active");
          navButtons.forEach((btn) => btn.classList.remove("hover"));
        });

      document
        .querySelector(".tt-header-holder")
        .addEventListener("mouseenter", () => {
          menuWrapper.classList.remove("active");
          navButtons.forEach((btn) => btn.classList.remove("hover"));
        });

      document
        .querySelector(".tt-desctop-menu")
        .addEventListener("mouseleave", (e) => {
          if (
            !e.relatedTarget?.classList.contains("primary-links-wrapper") &&
            !e.relatedTarget?.classList.contains("secondary-links-wrapper")
          ) {
            menuTimer = setTimeout(() => {
              menuWrapper.classList.remove("active");
              navButtons.forEach((btn) => btn.classList.remove("hover"));
            }, 100);
          }
        });
    };

    handleMenuClose();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMenu);
  } else {
    initMenu();
  }
})();
